import { isValidDateString } from '@/common/utils/dateValidator'
import { addDays, isAfter, isBefore, parse, startOfDay, subDays } from 'date-fns'
import { z } from 'zod'

export const createPaymentAdvanceSchemaFactory = (billDueAt?: string) =>
  z.object({
    requested_total: z
      .string()
      .min(1, { message: 'Campo obrigatório' })
      .refine((value) => value !== 'R$ 0,00', { message: 'O valor deve ser maior que zero' }),
    date_to_be_paid: z
      .string()
      .min(1, { message: 'Campo obrigatório' })
      .refine(
        (data) => {
          if (data.length < 10) return false
          return true
        },
        { message: 'Use uma data válida' },
      )
      .refine(
        (dateStr) => {
          if (!isValidDateString(dateStr)) return false

          const inputDate = parse(dateStr, 'dd/MM/yyyy', new Date())

          const today = startOfDay(new Date())
          const oneDayAfterToday = addDays(today, 1)

          return !isBefore(inputDate, oneDayAfterToday)
        },
        { message: 'A data deve ser pelo menos 1 dia após hoje' },
      )
      .refine(
        (dateStr) => {
          if (!isValidDateString(dateStr) || !billDueAt) return true

          const inputDate = parse(dateStr, 'dd/MM/yyyy', new Date())

          const billDueDate = new Date(billDueAt)
          const oneDayBeforeDue = subDays(billDueDate, 1)

          return !isAfter(inputDate, oneDayBeforeDue)
        },
        { message: 'A data deve ser pelo menos 1 dia antes do vencimento da fatura' },
      ),
  })

export const createPaymentAdvanceSchema = createPaymentAdvanceSchemaFactory()

export type CreatePaymentAdvanceValidationSchema = z.infer<typeof createPaymentAdvanceSchema>
